import { BubbleCell, DrawArgs, GridCellKind, type CustomCell, type CustomRenderer } from '@glideapps/glide-data-grid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { ThemeMode } from '@makyoapp/makyo-ui'

import { ISlugCell } from '@/core/models/columns/slug'

import { drawBubbles } from '../helpers/draw-fns'

export interface CustomSlugCellProps {
  readonly type: ColumnTypes
  readonly cell: ISlugCell
  readonly extra: { theme: ThemeMode }
}

export type CustomSlugCell = CustomCell<CustomSlugCellProps>

const CustomSlugRenderer: CustomRenderer<CustomSlugCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is CustomSlugCell => (cell.data as CustomSlugCellProps).type === ColumnTypes.Slug,
  draw: (args, cell) => {
    const cellValue = cell.data.cell.toString().trim()
    if (!cellValue) return false
    drawBubbles(args as unknown as DrawArgs<BubbleCell>, cellValue.split('#'), cell.data.extra.theme)
  },
}

export default CustomSlugRenderer
